<div class="question-pull question-pull--more">
  <div class="accordion accordion--controls">
    @for (group of grouping; track group; let i = $index) {
      <div class="accordion__item" [ngClass]="i === 0 ? 'position-relative': null">
        @if (classCount > 1) {
          <a href="#group-{{ group?.group_id }}" class="accordion__title " [ngClass]="i === 0 ? null : 'collapsed'" data-toggle="collapse" [attr.aria-expanded]="i === 0 ? 'true' : 'false'">
            <div class="accordion__title-text">
              <h5 class="font-normal">{{group?.group_name}}</h5>
            </div>
            <div class="accordion__title-caret">
              <svg class="icon"><use xlink:href="#dropdown"></use></svg>
            </div>
          </a>
        }
        <div class="accordion__body collapse" [ngClass]="i === 0 ? 'show' : null" id="group-{{group?.group_id}}">
          <div class="accordion__content">
            @for (class of getGroupingClasses(group); track class) {
              <div class="custom-traffic__group {{ (class?.del === 1 || class?.edit === 1) ? 'is-active':''}} " >
                <div class="custom-traffic {{class?.cent_aq_answer_id}}">
                  <div class="custom-traffic__body" >
                    <div class="custom-traffic__label" >
                      <div class="custom-traffic__icon">
                        <img src="{{class?.image_url}}" alt="" [fallbackImage]="'assets/class/sm-0.svg'" class="icon icon--lg">
                      </div>
                      <div class="custom-traffic__title"><h6>{{class?.answer}}</h6></div>
                      <div class="custom-traffic__indi">
                        @if (!class?.item_detail && (class?.del === 0 || class?.edit === 0)) {
                          <span class="fake-radio" (click)="checkRadio(class)" ></span>
                        }
                        @if (class?.included === 1) {
                          <span class="tag-pill tag-pill--category">Included</span>
                        }
                        <!--  <a *ngIf="class?.del === 1" href="javascript:;" (click)="questionService?.setSelectedCoverItem(class)" data-toggle="modal" class="icon-hover icon-hover--slim" data-tooltip="tooltip" data-placement="top" title="" data-original-title="Remove Cover">
                        <svg class="icon"><use xlink:href="#trash-bin"></use></svg>
                      </a>
                      <a *ngIf="class?.edit === 1" (click)="editModal(class)" href="javascript:;" class="icon-hover icon-hover--slim" data-tooltip="tooltip" data-placement="top" title="" data-original-title="Edit Policy">
                        <svg class="icon"><use xlink:href="#edit-underline"></use></svg>
                      </a>  -->
                    </div>
                    @if (class?.add === 1) {
                      <div class="custom-traffic__add">
                        <a href="javascript:;" (click)="addAnother(class)" class="button-control"><strong>Add another</strong></a>
                      </div>
                    }
                  </div>
                  <div class="custom-traffic__content">
                    <p class="readmore readmore--inline" data-widget="ReadMore" data-splitlength="25" data-more-text="read more" data-less-text="read less">
                      {{class?.info_comment}}
                    </p>
                  </div>
                  @if (classCount > 1) {
                    <div class="custom-traffic__more">
                      <!-- <a href="#cover-learn-more-modal" data-toggle="modal" class="button-control button-control--right button-control--tight button-control--xs">
                      <strong>Learn More</strong><svg class="icon">
                      <use xlink:href="#modal"></use>
                    </svg>
                  </a> -->
                </div>
              }
              @if (class?.item_detail) {
                <div class="custom-traffic__added">
                  @for (item of class?.item_detail; track item) {
                    <div class="cover-item">
                      <div class="cover-item__label">
                        {{item?.description}}
                      </div>
                      <div class="cover-item__amount">
                        <p><strong>{{item?.prem_value}}</strong>/{{questionService.currency?.display_freq}}</p>
                      </div>
                      <div class="cover-item__actions">
                        @if (item?.delete === 1 && classCount === 1) {
                          <a  href="javascript:;" (click)="removeClassItem(class, item?.item_id)" data-toggle="modal" class="icon-hover icon-hover--mobile-label" data-tooltip="tooltip" data-placement="top" title="" data-original-title="Remove Cover">
                            <svg class="icon icon--sm">
                              <use xlink:href="#trash-bin"></use>
                            </svg>
                            <strong>Remove</strong>
                          </a>
                        }
                        @if (item?.delete === 1 && classCount > 1) {
                          <a   href="javascript:;" (click)="removeClassItem(class, item?.item_id)" data-toggle="modal" class="icon-hover icon-hover--mobile-label" data-tooltip="tooltip" data-placement="top" title="" data-original-title="Remove Cover">
                            <svg class="icon icon--sm">
                              <use xlink:href="#trash-bin"></use>
                            </svg>
                            <strong>Remove</strong>
                          </a>
                        }
                        @if (class?.edit === 1) {
                          <a href="javascript:;" (click)="editModal(class, item?.item_id)" class="icon-hover icon-hover--mobile-label" data-tooltip="tooltip" data-placement="top" title="" data-original-title="Edit Cover">
                            <svg class="icon icon--sm">
                              <use xlink:href="#edit-underline"></use>
                            </svg>
                            <strong>Edit</strong>
                          </a>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
            @if (getItk(class)?.length > 0) {
              <div class="custom-traffic__carousel">
                <ngx-slick-carousel class="slider slider--compact slider--traffic"
                  #slickModal="slick-carousel"
                  [config]="trafficConfig">
                  @for (itk of getItk(class); track itk; let i = $index) {
                    <div ngxSlickItem style="max-width:100%" [attr.data-slick-index]="i" class="slider__slide" >
                      <p class="font-semibold mb-5">Important to know</p>
                      <p>{{itk.info_comment}}</p>
                    </div>
                  }
                </ngx-slick-carousel>
              </div>
            }
          </div>
          @if (getGroupingClasses(group,class)?.length > 0 && classCount > 1) {
            <div class="custom-traffic__children">
              <p>
                <small class="font-semibold">{{class?.dependency_label}}
                  @if (class?.tooltip) {
                    <a class="popover-trigger popover-trigger--sm" tabindex="0" data-toggle="popover"
                      data-trigger="focus" data-html="true" data-placement="right"
                      [attr.data-content]="class?.tooltip">
                      <svg class="icon icon--sm">
                        <use xlink:href="#help-Icon"></use>
                      </svg>
                    </a>
                  }
                </small>
              </p>
              @for (level2 of getGroupingClasses(group,class); track level2) {
                <div class="custom-traffic custom-traffic--child {{level2?.cent_aq_answer_id}} {{ (level2?.del === 1 || level2?.edit === 1) ? 'is-active':''}} {{ level2?.disabled === 1 ? 'is-disabled':'' }}">
                  <div class="custom-traffic__body" >
                    <div class="custom-traffic__label">
                      <div class="custom-traffic__icon">
                        <img src="{{level2?.image_url}}" alt="" [fallbackImage]="'assets/class/sm-0.svg'" class="icon icon--lg">
                      </div>
                      <div class="custom-traffic__title"><h6>{{level2?.answer}}</h6></div>
                      <div class="custom-traffic__indi">
                        @if ((level2?.del === 0 || level2?.edit === 0) && level2?.disabled !== 1) {
                          <span class="fake-radio" (click)="checkRadio(level2)"></span>
                        }
                        <!-- <a *ngIf="level2?.del === 1" href="javascript;" (click)="questionService?.setSelectedCoverItem(level2)"  data-toggle="modal" class="icon-hover icon-hover--slim" data-tooltip="tooltip" data-placement="top" title="" data-original-title="Remove Cover">
                        <svg class="icon"><use xlink:href="#trash-bin"></use></svg>
                      </a>
                      <a *ngIf="level2?.edit === 1" href="javascript:;" class="icon-hover icon-hover--slim" data-tooltip="tooltip" data-placement="top" title="" data-original-title="Edit Policy">
                        <svg class="icon"><use xlink:href="#edit-underline"></use></svg>
                      </a> -->
                    </div>
                  </div>
                  <div class="custom-traffic__content">
                    <p class="readmore readmore--inline" data-widget="ReadMore" data-splitlength="25" data-more-text="read more" data-less-text="read less">
                      {{level2?.info_comment}}
                    </p>
                  </div>
                  @if (level2?.item_detail) {
                    <div class="custom-traffic__added">
                      @for (item of level2?.item_detail; track item) {
                        <div class="cover-item">
                          <div class="cover-item__label">
                            {{item?.description}}
                          </div>
                          <div class="cover-item__amount">
                            <p><strong>{{item?.prem_value}}</strong>/{{questionService.currency?.display_freq}}</p>
                          </div>
                          <div class="cover-item__actions">
                            @if (class?.del === 1) {
                              <a href="javascript:;" (click)="removeClassItem(level2, item?.item_id)"  data-toggle="modal" class="icon-hover icon-hover--mobile-label" data-tooltip="tooltip" data-placement="top" title="" data-original-title="Remove Cover">
                                <svg class="icon icon--sm">
                                  <use xlink:href="#trash-bin"></use>
                                </svg>
                                <strong>Remove</strong>
                              </a>
                            }
                            @if (class?.edit === 1) {
                              <a href="javascript:;" (click)="editModal(level2)" class="icon-hover icon-hover--mobile-label" data-tooltip="tooltip" data-placement="top" title="" data-original-title="Edit Cover">
                                <svg class="icon icon--sm">
                                  <use xlink:href="#edit-underline"></use>
                                </svg>
                                <strong>Edit</strong>
                              </a>
                            }
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
<div class="guide guide--traffic-cover-location" id="guide-1-tip-3" >
  <div class="guide__close">
    <svg class="icon">
      <use xlink:href="#close-circle-small"></use>
    </svg>
  </div>
  <div class="guide__content">
    <p>For each location, include location-based coverage. Add as much cover as you like.
    </p>
  </div>
  <div class="guide__tray">
    <div class="guide__progress">3 / 4</div>
    <div class="guide__btn">
      <a href="#guide-1-tip-4" data-guide-btn="next"
      class="button button--sm button--everything">Next</a>
    </div>
  </div>
</div>
</div>
}

</div>
@if (classCount > 1) {
  <hr class="hr--bdr mb-0">
}
<h5 class="mt-30 mb-20 position-relative">
  {{nonLocation[0]?.group_name}}
  <div class="guide guide--traffic-non-location" id="guide-1-tip-4">
    <div class="guide__close">
      <svg class="icon">
        <use xlink:href="#close-circle-small"></use>
      </svg>
    </div>
    <div class="guide__content">
      <p>You can also add non-location-based coverage that applies to the entire policy. You
      only need to add this type of cover once.</p>
    </div>
    <div class="guide__tray">
      <div class="guide__progress">4 / 4</div>
      <div class="guide__btn">
        <a href="#" data-guide-btn="end" class="button button--sm button--everything">Got
        it</a>
      </div>
    </div>
  </div>
</h5>
<div class="question-pull question-pull--slider">
  <ngx-slick-carousel class="slider slider--cover slider--mh" id="cover-slider" [config]="slideConfig">
    @for (class of nonLocation; track class; let i = $index) {
      <div ngxSlickItem [attr.data-slick-index]="i" class="slider__slide"
        >
        <div class="slider__slide-inner">
          <label class="custom-input custom-input--radio custom-input--icon-cover-alt is-active">
            <input type="checkbox" [disabled]="class?.disabled === 1 ? 'disabled':null" name="checkbox-example-1"
              (click)="checkRadio(class, $event)" />
              <span class="custom-input__label">
                <img src="/assets/icn/class/sm-benefit.svg" class="icon" alt="" />
                <h5 class="font-16">{{class?.answer}}</h5>
                <p class="readmore readmore--inline" data-widget="ReadMore" data-splitlength="15"
                data-more-text="read more" data-less-text="read less" [innerHTML]="class?.info_comment"></p>
                @if (class?.del === 1) {
                  <span class="custom-input__actions">
                    <a href="javascript:;" data-toggle="modal" (click)="removeClassItem(class, 1)"
                      class="icon-hover icon-hover--mobile-label" data-tooltip="tooltip" data-placement="top" title=""
                      data-original-title="Remove Cover" tabindex="0">
                      <svg class="icon icon--sm">
                        <use xlink:href="#trash-bin"></use>
                      </svg>
                      <strong>Remove</strong>
                    </a>
                    @if (class?.edit === 1) {
                      <a href="javascript:;" (click)="editModal(class)"
                        class="icon-hover icon-hover--mobile-label" data-tooltip="tooltip" data-placement="top" title=""
                        data-original-title="Edit Cover" tabindex="0">
                        <svg class="icon icon--sm">
                          <use xlink:href="#edit-underline"></use>
                        </svg>
                        <strong>Edit</strong>
                      </a>
                    }
                  </span>
                }
              </span>
              @if (class?.edit === 0) {
                <span class="custom-input__indi"></span>
              }
              @if (class?.edit === 1 && class?.item_detail) {
                <span class="custom-input__price">
                  <p><strong>{{class?.item_detail[0]?.prem_value}}</strong>/{{questionService.currency?.display_freq}}</p>
                </span>
              }
            </label>
          </div>
        </div>
      }
    </ngx-slick-carousel>
    <!-- <div class="slider slider--cover slider--mh" id="cover-slider">
    <div class="slider__slide" *ngFor="let class of nonLocation">
      <div class="slider__slide-inner">
        <label class="custom-input custom-input--radio custom-input--icon-cover-alt is-active">
          <input type="checkbox" [disabled]="class?.disabled === 1 ? 'disabled':null" name="checkbox-example-1"
            (click)="checkRadio(class, $event)" />
            <span class="custom-input__label">
              <img src="/assets/icn/class/sm-benefit.svg" class="icon" alt="" />
              <h5 class="font-16">{{class?.answer}}</h5>
              <p class="readmore readmore--inline" data-widget="ReadMore" data-splitlength="15"
              data-more-text="read more" data-less-text="read less" [innerHTML]="class?.info_comment"></p>
              <span *ngIf="class?.del === 1" class="custom-input__actions">
                <a href="javascript:;" data-toggle="modal" (click)="removeClassItem(class, 1)"
                  class="icon-hover icon-hover--mobile-label" data-tooltip="tooltip" data-placement="top" title=""
                  data-original-title="Remove Cover" tabindex="0">
                  <svg class="icon icon--sm">
                    <use xlink:href="#trash-bin"></use>
                  </svg>
                  <strong>Remove</strong>
                </a>
                <a href="javascript:;" *ngIf="class?.edit === 1" (click)="editModal(class)"
                  class="icon-hover icon-hover--mobile-label" data-tooltip="tooltip" data-placement="top" title=""
                  data-original-title="Edit Cover" tabindex="0">
                  <svg class="icon icon--sm">
                    <use xlink:href="#edit-underline"></use>
                  </svg>
                  <strong>Edit</strong>
                </a>
              </span>
            </span>
            <span *ngIf="class?.edit === 0" class="custom-input__indi"></span>
            <span *ngIf="class?.edit === 1 && class?.item_detail" class="custom-input__price">
              <p><strong>{{class?.item_detail[0]?.prem_value}}</strong>/{{questionService.currency?.display_freq}}</p>
            </span>
          </label>
        </div>
      </div>

    </div> -->
  </div>
</div>

<!-- <div class="form-group form-group--sm">
<label
  class="custom-input custom-input--radio custom-input--pill-complex"
  >
  <input
    type="radio"
    (click)="nothinMore($event)"
    name="nothing-more"/>
    <span class="custom-input__indi"></span>
    <span class="custom-input__label">Nothing More</span>
  </label>
</div> -->
@if (removeModal?.length > 0) {
  <dialog class="dialog" id="remove-section-modal">
    <div class="dialog-inner">
      <div class="dialog-content modal-alert modal-alert--alt">
        <div class="modal-alert__heading">
          <div class="container">
            <div class="modal-alert__avatar">
              <img src="assets/{{question?.category_id}}/avatar/happy.png" class="img-fluid" alt="">
            </div>
            <a href="#" class="modal-alert__close" data-dismiss="dialog">
              <svg class="icon">
                <use xlink:href="#close-medium"></use>
              </svg>
            </a>
          </div>
        </div>
        <div class="modal-alert__content">
          <div class="container">
            <div class="rte text-left">
              <h4>{{removeModal[0]?.value}}</h4>
              <ul [innerHTML]="removeModal[1]?.value">
              </ul>
            </div>
          </div>
        </div>
        <div class="modal-alert__button">
          <div class="container">
            <a href="#" data-toggle="modal" data-dismiss="dialog" class="button button--lg button--secondary">No, keep it</a>
            <a id="remove-cover-btn" href="javascript:;" (click)="removeSection()" data-toggle="modal" data-dismiss="dialog"class="button button--lg button--primary">Yes, remove it</a>
          </div>
        </div>
      </div>
    </div>
    <div class="ui-selectmenu-menu ui-front"><ul aria-hidden="true" aria-labelledby="ui-id-1-button" id="ui-id-1-menu" role="listbox" tabindex="0" class="ui-menu ui-corner-bottom ui-widget ui-widget-content"></ul></div>
  </dialog>
}



